import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { AuthService } from '@services/auth.service';
import { of, switchMap } from 'rxjs';

export const notBannedGuard: CanActivateFn = () => {
    const authService: AuthService = inject(AuthService);
    const navController: NavController = inject(NavController);

    return authService.checkAuthentication().pipe(
        switchMap((authenticated) => {
            if (!authenticated) {
                navController.navigateRoot('/');
                return of(false);
            }

            if (!authService.user) {
                navController.navigateRoot('/');
                return of(false);
            }

            if (!authService.user.is_banned) {
                navController.navigateRoot('/');
                return of(false);
            }

            return of(true);
        })
    );
};
